import React from "react";
import ReactDOM from "react-dom";
import Logger, { LOG_LEVELS } from "./utils/log";
import * as FullStory from "@fullstory/browser";

import AppConfig from "./utils/appConfig";
import SaaSWebApp from "./SaaSWebApp";

import QueryString from "query-string";

import getClientConfig from './utils/getClientConfig';
import { authService } from './utils/authService';

const MODULE_NAME = "MAIN_APP";
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);
/**
 * Safety net if anything goes wrong hear
 */
try {
    //Initialize full-story
    const FULL_STORY_CONFIG = AppConfig.FullStoryConfig;
    FullStory.init(FULL_STORY_CONFIG);
    window["_fs_ready"] = function () {
        log.debug("FullStory client API is ready.");
    };
} catch (error) {
    log.debug("Error: Full story init failed!", error);
}

try{
    // Initialize MVR Partition. Need to improve this. Do in a more "react" way. 
    const parsedQS = QueryString.parse(location.search);
    log.info("QS:", parsedQS);
    if (parsedQS.customerId) {
        log.info("CID:", parsedQS.customerId);
        localStorage.mvrCustomerId = parsedQS.customerId;
    } else {
    //   delete localStorage.mvrCustomerId;
    }
} catch(err) {
    log.error("Error: MVR QueryString Failed", err);
}

const { enableAvalaraIdentityJwt } = getClientConfig();
if (enableAvalaraIdentityJwt) {
    const tokenRefresher = async () => {
        try {
            const timeToExpire = authService.timeToExpire();
            log.info(`tokenRefresher - Time to expire: ${timeToExpire}`)
    
            // If there's only 3 minutes left of validity, attempt to refresh the token.
            if (timeToExpire < 180) {
                await authService.refreshToken();
            }
        } catch (error) {
            log.error("tokenRefresher: Failed to refresh token :", error)
        } finally {
            setTimeout(() => {
                tokenRefresher();
            }, 30000);
        }
    }

    tokenRefresher()
        .then()
        .catch(error => {
            log.error("tokenRefresher - Error refreshing token", error);
        });
}

const onAuthenticationCompleteHandler = (error, authInfo) => {
    //If login is successful
    if (!error && authInfo && authInfo.customerId) {
        try {
            //Setup a customer id as an identifier for the current user
            FullStory.identify(authInfo.customerId, {
                email: authInfo.userName || "",
                role: authInfo.role || "",
                products: (authInfo.products || []).join(","),
            });
        } catch (identityError) {
            log.debug("Error: Failed to set full story user identity!", identityError);
        }
    }
};

const onLogoutCompleteHandler = () => {
    try {
        //Anonymize full story user
        FullStory.identify(false);
    } catch (error) {
        log.debug("Error: Failed to anonymize full story user!", error);
    }
};
// Creates the Redux reducer with the redux-thunk middleware, which allows us
// to do asynchronous things in  the actions
// const store = createStore( combineReducers({homeReducer: homeReducer, router: routerReducer}), applyMiddleware(thunk, routerMiddleware(browserHistory)));

// Mostly boilerplate, except for the Routes. These are the pages you can go to,
// which are all wrapped in the App component, which contains the navigation etc
ReactDOM.render(
    <SaaSWebApp
        onAuthenticationComplete={onAuthenticationCompleteHandler}
        onLogoutComplete={onLogoutCompleteHandler}
    />,
    document.querySelector("div.saas-vat-reporting-root")
);
